import ClientCookies from 'js-cookie'
import Prismic from 'prismic-javascript'

export default function(api, ctx) {
  let previewRef, masterRef, ref
  if (ctx.req) {
    // server version
    const Cookies = require('cookies')
    const cookies = new Cookies(ctx.req, ctx.res)
    previewRef = cookies.get(Prismic.previewCookie)
    masterRef = api.refs.find(ref => {
      return ref.isMasterRef === true
    })
    ref = previewRef || masterRef.ref
  } else {
    // client version
    previewRef = ClientCookies.get(Prismic.previewCookie)
    masterRef = api.refs.find(ref => {
      return ref.isMasterRef === true
    }).ref
    ref = previewRef || masterRef
  }
  return ref
}
